/** @format */

import React from "react";
import style from "../common.module.scss";
import cn from "classnames";
import DocumentNewIcon from "../../../shared/icons/DocumentNewIcon";
import DeleteNewIcon from "../../../shared/icons/DeleteNewIcon";
import AddressTypeSwitch from "./AddressTypeSwitch";

const OrdersSectionItemWrapper = ({
  title,
  children,
  withShadow = false,
  isCompact = false,
  isMobile = false,
  isHide = false,
  column = 1,
  isEditable,
  marginBottom = 0,
  counter = 1,
  isShadow = false,
  isPSmall = false,
  isMrAuto = false,
  isDelete = false,
  deleteIntermediatePoint,
  prefixStart = "",
  isCunter = true,
  isCopy = false,
  isTable = false,
  addressType,
  onAddressTypeChange,
}) => {
  return (
    <div
      className={cn(style.wrapper, {
        [style.isCompact]: isCompact,
        [style.isMobile]: isMobile,
        [style.withShadow]: withShadow,
        [style.hide]: isHide,
        [style.isShadow]: isShadow,
      })}
      style={{
        marginBottom: marginBottom ? marginBottom + "px" : marginBottom,
      }}
    >
      <div
        className={cn(
          style.wrapper_content,
          { [style.pSmall]: isPSmall },
          { [style.pCopy]: isCopy },
          { [style.pZero]: isTable },
          { [style.mrRightAuto]: isMrAuto },
        )}
      >
        {title && (
          <div className={style.headerSub}>
            <div
              className={cn([style.display_flex, style.display_f1, style.display_center], [style.display_gap])}
            >
              {isCunter && (
                <div className={cn(style.counter, { [style.counter_bgRed]: isDelete })}>
                  {counter}
                </div>
              )}
              {prefixStart && <div>{prefixStart}</div>}
              <h3 className={cn(style.titleSub,{[style.titleIscopy]: isCopy})}>{title}</h3>
              {addressType !== undefined && (
                <AddressTypeSwitch
                  value={addressType}
                  onChange={onAddressTypeChange}
                />
              )}
              {isDelete && (
                <DeleteNewIcon
                  style={{ cursor: "pointer"}}
                  onClick={deleteIntermediatePoint}
                />
              )}
            </div>
            {isEditable && (
              <button type="button" className={cn("ms-auto", style.editableBtn)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    d="M17.0318 8.51049L13.4506 4.96638L14.6303 3.78501C14.9533 3.46154 15.3502 3.2998 15.8209 3.2998C16.2917 3.2998 16.6883 3.46154 17.0107 3.78501L18.1904 4.96638C18.5134 5.28985 18.682 5.68026 18.696 6.13762C18.71 6.59498 18.5556 6.98512 18.2325 7.30802L17.0318 8.51049ZM15.81 9.75515L6.87807 18.6998H3.29688V15.1135L12.2288 6.16885L15.81 9.75515Z"
                    fill="#909195"
                  />
                </svg>
              </button>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default OrdersSectionItemWrapper;
